const calendarConfig = {
	timezone: 'America/Los_Angeles',
};

/*
export const CALENDAR_EVENT_TYPE_IDS = {
	"equipment-shift-open": "equipment-shift-open",
	"equipment-shift": "equipment-shift"
};
 */

const dayColor = { r : 205, g : 167, b : 12};
const dayColorOpenFont = { r : 159, g : 129, b : 9};
const nightColor = { r : 65, g : 92, b : 118};
const unavailableColor = { r : 100, g: 100, b : 100};
function rgba(rgb, a) {
	const { r, g, b} = rgb;
	return `rgba(${r},${g},${b},${a})`;
}

const DAY_SHIFT_ID = 1;
const NIGHT_SHIFT_ID = 2;

export function getStyleForShiftId({ shiftId, status, equipmentIsTbd, isOdd}) {

	if (status === 'unavailable') {
		return {
			backgroundColor : rgba(unavailableColor, .3),
			color : '#666',
			//background: `linear-gradient(to right, ${rgba(dayColor, .3)} 1%,${rgba(nightColor, .3)} 100%)`,
		};
	} else if (status === 'open') {
		if (shiftId === DAY_SHIFT_ID) {
			return {
				backgroundColor : rgba(dayColor, .3),
				color : rgba(dayColorOpenFont, 1),
			};
		} else if (shiftId === NIGHT_SHIFT_ID) {
			return {
				backgroundColor : rgba(nightColor, .3),
				color : rgba(nightColor, 1),
			};
		}
	} else {
		if (shiftId === DAY_SHIFT_ID) {
			if (equipmentIsTbd) {
				return {
					color : `#fff`,
					background: `repeating-linear-gradient(45deg,` +
						`${rgba(dayColor, .8)},` +
						`${rgba(dayColor, .8)} 10px,` +
						`${rgba(dayColor, .9)} 10px,` +
						`${rgba(dayColor, .9)} 20px)`,
				};
			} else {

				const opacity = (isOdd === 0) ? .75 : 1;
				return {
					backgroundColor: rgba(dayColor, opacity),
					color: '#fff',
				};
			}
		} else if (shiftId === NIGHT_SHIFT_ID) {

			if (equipmentIsTbd) {
				return {
					color: `#fff`,
					background: `repeating-linear-gradient(45deg,` +
						`${rgba(nightColor, .95)},` +
						`${rgba(nightColor, .95)} 10px,` +
						`${rgba(nightColor, 1)} 10px,` +
						`${rgba(nightColor, 1)} 20px)`,
				};
			} else {
				const opacity = (isOdd === 0) ? .8 : 1;
				return {
					backgroundColor: rgba(nightColor, opacity),
					color: '#fff',
				};
			}
		}
	}

	return {
		backgroundColor : '#f1f1f1',
		color : '#444',
	};
}

export function getNumberOfDaysBreakPoint (v) {
	if (v === 'oneMonth') { return { nodIsLarge : true } }
	else if (v >= 20) { return { nodIsLarge : true } }
	else if (v >= 12) { return { nodIsMedium : true } }
	else {return { nodIsSmall : true } }
}

export default calendarConfig;
